import { getLegacyBindingContext } from "@visactor/vrender-core/legacy/bootstrap";

import { registerArcGraphic } from "@visactor/vrender-core/register/graphic";

import { arcModule } from "@visactor/vrender-core/graphic/modules";

import { browser } from "./env";

import { bindArcCanvasPickerContribution } from "../picker/contributions/canvas-picker/arc-module";

import { bindArcMathPickerContribution } from "../picker/contributions/math-picker/arc-module";

export function _registerArc() {
    if (_registerArc.__loaded) return;
    _registerArc.__loaded = !0;
    const legacyContext = getLegacyBindingContext();
    registerArcGraphic(), arcModule({
        bind: legacyContext.bind
    }), browser ? bindArcCanvasPickerContribution(legacyContext) : bindArcMathPickerContribution(legacyContext);
}

_registerArc.__loaded = !1;

export const registerArc = _registerArc;
//# sourceMappingURL=register-arc.js.map